var _path, _path2, _g, _path3, _rect, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 139,
    viewBox: "0 0 138 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2991 28.7326C92.9317 23.1331 89.5409 18.1028 85.2299 13.7763C80.919 9.46023 75.8844 6.06531 70.2916 3.69508C64.5023 1.24204 58.3409 0 52.0037 0C43.6093 0 35.3699 2.24603 28.1747 6.48968C21.2689 10.5677 15.49 16.3639 11.4375 23.2883L12.1301 23.692C20.4005 9.56374 35.649 0.807329 52.0037 0.807329C77.4765 0.807329 98.1937 21.5495 98.1937 47.0528C98.1937 72.4629 77.6212 93.1533 52.2725 93.2982V94.1055C58.527 94.0745 64.585 92.8324 70.3019 90.4104C75.8947 88.0402 80.919 84.6453 85.2403 80.3292C89.5512 76.0131 92.9421 70.9725 95.3095 65.3729C97.7596 59.5767 99.0001 53.4079 99.0001 47.0631C99.0001 40.7183 97.7492 34.5392 95.2991 28.7326Z",
    fill: "#6F5C91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81749 47.0425C7.81749 40.3252 9.33718 33.7009 12.2525 27.7081C12.8004 26.5799 12.3972 25.224 11.3117 24.603L11.26 24.5719C10.0608 23.8784 8.53081 24.3442 7.92087 25.5966C6.58728 28.3394 5.51213 31.1961 4.7161 34.1253C3.57893 38.3172 3 42.6643 3 47.0425C3 53.6668 4.29225 60.0944 6.85606 66.139C9.32684 71.9766 12.8521 77.2242 17.3594 81.737C21.8565 86.2394 27.0978 89.7792 32.9388 92.253C37.9113 94.3541 43.1423 95.6065 48.5181 95.9894C49.9034 96.0826 51.0716 94.9958 51.0716 93.6088V93.5571C51.0716 92.2943 50.0998 91.2697 48.8386 91.1765C25.94 89.5308 7.81749 70.3619 7.81749 47.0425Z",
    fill: "#6F5C91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_691_1623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0023 87.2454C74.178 87.2454 92.155 69.2469 92.155 47.0446C92.155 24.8423 74.178 6.84375 52.0023 6.84375C29.8266 6.84375 11.8496 24.8423 11.8496 47.0446C11.8496 69.2469 29.8266 87.2454 52.0023 87.2454Z",
    fill: "url(#paint0_linear_691_1623)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3886 86.4055C73.8392 86.4055 91.2283 68.9955 91.2283 47.5191C91.2283 26.0428 73.8392 8.63281 52.3886 8.63281C30.938 8.63281 13.5488 26.0428 13.5488 47.5191C13.5488 68.9955 30.938 86.4055 52.3886 86.4055Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.1759,
    height: 45.1789,
    transform: "translate(28.4121 25.4062)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9384 58.2792L66.8393 52.1699C67.8511 50.1014 68.3858 47.8009 68.3894 45.4863C68.3956 41.4616 66.8386 37.6562 64.0051 34.7711C61.171 31.8854 57.3944 30.261 53.3709 30.1973C49.1989 30.1314 45.2773 31.7184 42.3291 34.6668C39.4862 37.5097 37.9095 41.2577 37.8595 45.2628C35.0576 47.3725 33.4039 50.6618 33.4093 54.1751C33.4119 55.8192 33.7819 57.4534 34.4831 58.9313L33.0372 63.1391C32.7887 63.8625 32.9702 64.6479 33.5111 65.1888C33.8917 65.5695 34.3935 65.7722 34.9096 65.7722C35.1267 65.7722 35.3464 65.7363 35.5606 65.6627L39.7682 64.2167C41.246 64.9179 42.8802 65.288 44.5241 65.2906C44.5301 65.2906 44.5357 65.2906 44.5416 65.2906C48.107 65.2904 51.4211 63.5939 53.523 60.7231C55.7103 60.6655 57.8744 60.136 59.8309 59.1789L65.9398 61.2781C66.1943 61.3656 66.4554 61.4082 66.7134 61.4082C67.3266 61.4082 67.923 61.1674 68.3754 60.7149C69.018 60.0721 69.2337 59.1388 68.9384 58.2792ZM44.5415 63.1392C44.5369 63.1392 44.532 63.1392 44.5274 63.1392C43.0724 63.137 41.6274 62.7783 40.349 62.1019C40.0861 61.9629 39.7775 61.9388 39.4964 62.0354L35.1819 63.518L36.6644 59.2033C36.761 58.9221 36.737 58.6135 36.5979 58.3507C35.9216 57.0721 35.5628 55.6271 35.5606 54.1718C35.557 51.831 36.4675 49.6124 38.0597 47.9511C38.5798 51.1218 40.0909 54.0436 42.4331 56.3444C44.7581 58.6281 47.6805 60.0821 50.8338 60.5575C49.1688 62.1987 46.9244 63.1392 44.5415 63.1392ZM66.854 59.1936C66.7929 59.2548 66.7203 59.2715 66.6387 59.2434L60.0989 56.996C59.9853 56.957 59.8672 56.9376 59.7494 56.9376C59.5758 56.9376 59.4029 56.9796 59.2464 57.0625C57.3792 58.0504 55.2692 58.5743 53.1443 58.5775C53.1374 58.5775 53.131 58.5775 53.124 58.5775C46.0044 58.5775 40.1235 52.7936 40.0107 45.6752C39.9539 42.0902 41.3175 38.7209 43.8502 36.188C46.383 33.655 49.7526 32.2918 53.3369 32.3483C60.4617 32.4613 66.2492 38.3534 66.2382 45.4829C66.2349 47.6079 65.711 49.7181 64.7233 51.5853C64.5842 51.8481 64.5602 52.1568 64.6568 52.4379L66.904 58.9782C66.932 59.06 66.9152 59.1325 66.854 59.1936Z",
    fill: "#6F5C91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5321 39.7578H46.7162C46.1222 39.7578 45.6406 40.2394 45.6406 40.8334C45.6406 41.4275 46.1222 41.909 46.7162 41.909H59.5321C60.1262 41.909 60.6077 41.4274 60.6077 40.8334C60.6077 40.2394 60.1262 39.7578 59.5321 39.7578Z",
    fill: "#6F5C91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5321 44.2031H46.7162C46.1222 44.2031 45.6406 44.6847 45.6406 45.2787C45.6406 45.8727 46.1222 46.3543 46.7162 46.3543H59.5321C60.1262 46.3543 60.6077 45.8727 60.6077 45.2787C60.6077 44.6847 60.1262 44.2031 59.5321 44.2031Z",
    fill: "#6F5C91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.599 48.6094H46.7162C46.1222 48.6094 45.6406 49.091 45.6406 49.685C45.6406 50.2791 46.1222 50.7606 46.7162 50.7606H54.5989C55.1929 50.7606 55.6745 50.279 55.6745 49.685C55.6745 49.091 55.193 48.6094 54.599 48.6094Z",
    fill: "#6F5C91"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_691_1623",
    x: 0.555637,
    y: 1.19676,
    width: 136.775,
    height: 136.868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.941,
    dy: 22.5879
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_691_1623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_691_1623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_1623",
    x1: 76.9955,
    y1: 78.5026,
    x2: 26.9321,
    y2: 15.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/card5.8ca360380feb7374368e7b353fcbf299.svg";
export { ForwardRef as ReactComponent };